export const formatBRL = (n: number) => n.toLocaleString('pt-BR', {style:'currency', currency:'BRL'});
